var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMedium(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 65,
    viewBox: "0 0 91 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1332_4327",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 91,
    height: 65
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 91,
    height: 65,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1332_4327)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.7199 58.0442L45.255 64.5091L38.79 58.0442C42.36 54.4742 48.15 54.4742 51.7199 58.0442Z",
    fill: "#285AC8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.649 45.1135L58.1841 51.5785C51.0429 44.4373 39.4655 44.4373 32.3243 51.5785L25.8594 45.1135C36.5705 34.4024 53.9379 34.4024 64.649 45.1135Z",
    fill: "#285AC8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.5801 32.1843L71.1152 38.6493C56.8328 24.3669 33.678 24.3669 19.3956 38.6493L12.9307 32.1843C30.783 14.332 59.7278 14.332 77.5801 32.1843Z",
    fill: "#285AC8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.5092 19.2546L84.0443 25.7196C62.6208 4.29605 27.8885 4.29605 6.46494 25.7196L0 19.2546C24.9935 -5.73884 65.5158 -5.73884 90.5092 19.2546Z",
    fill: "#B4B4B4"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedium);
export default __webpack_public_path__ + "static/media/medium.87beebdaa410e2fa6761105837d40d49.svg";
export { ForwardRef as ReactComponent };